<template>
统计
</template>

<script>
export default {
  name: "statistics"
}
</script>

<style scoped>

</style>